import type { Theme } from '@mui/material/styles'

const MuiPaper = (baseTheme: Theme) => ({
  styleOverrides: {
    root: {
      borderRadius: baseTheme.spacing(1),
    },
  },
})

export default MuiPaper
